import React from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import CategoriesViewTable from '../../../../components/CategoryView/CategoriesViewTable';

const CategoryManagerModal = ({ locationId, open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Modificar categorías</DialogTitle>
      <DialogContent>
        <CategoriesViewTable
          locationId={ locationId } 
         />
      </DialogContent>
    </Dialog>
  );
};

export default CategoryManagerModal;
